import React from "react";
import LeaksMercyLogo from "../logo8.png";

const MegaLogo = ({ size = 40 }) => {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
      }}
    >
      {/* LeaksMercy Logo Image */}
      <img
        src={LeaksMercyLogo}
        alt="LeaksMercy Logo"
        style={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
        }}
      />

      {/* LeaksMercy Text */}
      <div style={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
        <span
          style={{
            fontSize: size * 0.55,
            fontWeight: 900,
            letterSpacing: "3px",
            color: "#e50000",
            textTransform: "uppercase",
            fontFamily: "'Arial Black', sans-serif",
          }}
        >
          LEAKS
        </span>
        <span
          style={{
            fontSize: size * 0.22,
            color: "#999",
            letterSpacing: "2px",
            textTransform: "uppercase",
          }}
        >
          MERCY
        </span>
      </div>
    </div>
  );
};

export default MegaLogo;
